import { render } from "./DataSiniestro.vue?vue&type=template&id=4b9e30cb&scoped=true"
import script from "./DataSiniestro.vue?vue&type=script&lang=js"
export * from "./DataSiniestro.vue?vue&type=script&lang=js"

import "./DataSiniestro.vue?vue&type=style&index=0&id=4b9e30cb&lang=css"
import "./DataSiniestro.vue?vue&type=style&index=1&id=4b9e30cb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9e30cb"]])

export default __exports__